import { useContext } from "react";
import { ConfigContext } from "../../../../utils/ConfigContext";
import { MdOutlineNotificationsActive } from "../../../Icons";

const NotificationMenu = () => {
  const { config } = useContext(ConfigContext);
  if (!config.allowPushNotifications) return;

  return (
    <div
      style={{
        top: -4,
        right: 10,
        marginRight: 6,
        display: "flex",
      }}
    >
      <MdOutlineNotificationsActive width="18px" height="18px" />
    </div>
  );
};

export default NotificationMenu;
